import {
  ValidatorFn,
  FormControl,
  Validators,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';

export const createRequiredStringControl = (
  aditionalValidators: ValidatorFn[] = [],
): FormControl<string> => {
  return new FormControl<string>('', {
    nonNullable: true,
    validators: [Validators.required, ...aditionalValidators],
  });
};

export const unwantedDomainValidator = (): ValidatorFn => {
  const UNWANTED_DOMAINS = [
    'gmail.com',
    'yahoo.com',
    'hotmail.com',
    'aol.com',
    'outlook.com',
  ];
  return (control: AbstractControl<string>): ValidationErrors | null => {
    const domain = control.value.split('@')[1];
    return UNWANTED_DOMAINS.includes(domain) ? { unwantedDomain: true } : null;
  };
};
